//For localhost
// const apiBaseFrontUrl = 'http://localhost:3000';

//For Live Server
const apiBaseFrontUrl = 'https://cashflow.cmtprooptiki.gr';



export default apiBaseFrontUrl;